import { MissionTracking } from '../../../lib/types/models/mission-tracking/mission-tracking'
import { MissionTrackingInput } from '../../../lib/types/models/mission-tracking/mission-tracking-input'

export function mapMissionTrackingToInput(missionTracking: MissionTracking): MissionTrackingInput {
  return {
    startDate: missionTracking.startDate,
    endDate: missionTracking.endDate
  }
}
